import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';

//import { Link } from "react-router-dom";
import "./modalwarnings.css";
import { useSelector } from "react-redux";

function CamWarningCard() {
  const alignFace = useSelector((state) => state.warning.alignFace);
  const examStarted = useSelector((state) => state.timer.examStarted);
  // const [camWarning, setCamWarning] = useState(false);


  return (
    <CSSTransition
    in={(alignFace && examStarted)}
    timeout={500}
    classNames="animate"
    unmountOnExit
  > 
    <div className="my-2">
      <Card>
        <Card.Body>
          <div className="d-flex">
            <svg
              width="25"
              height="25"
              viewBox="0 0 65 65"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.7802 23.1044C43.7802 28.9637 39.0822 33.662 33.2187 33.662C27.3571 33.662 22.6572 28.9637 22.6572 23.1044C22.6572 17.245 27.3571 12.5487 33.2187 12.5487C39.0822 12.5487 43.7802 17.245 43.7802 23.1044ZM33.2183 52.4485C24.5647 52.4485 17.2583 51.042 17.2583 45.6156C17.2583 40.1872 24.6106 38.8305 33.2183 38.8305C41.8739 38.8305 49.1783 40.237 49.1783 45.6635C49.1783 51.0919 41.826 52.4485 33.2183 52.4485Z"
                fill="#200E32"
              />
              <path
                d="M47.5019 17.3947L18.1147 46.7819"
                stroke="#EB0909"
                strokeWidth="5.47995"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47.5094 46.7966L18.0977 17.3788"
                stroke="#EB0909"
                strokeWidth="5.47995"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.71826 18.6691V3.38C1.71826 2.06556 2.78382 1 4.09826 1H18.7508M1.71826 46.5779V61.62C1.71826 62.9344 2.78382 64 4.09826 64H18.7508M63.2818 18.6691V3.38C63.2818 2.06556 62.2162 1 60.9018 1H47.2753M63.2818 46.5779V61.62C63.2818 62.9344 62.2162 64 60.9018 64H47.2753"
                stroke="#EB0909"
                strokeWidth="1.83912"
              />
            </svg>
            <Card.Title className="px-2">Warning!</Card.Title>
          </div>
          <Card.Text className="warn-text">
            Align your face to the webcam
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
    </CSSTransition>
  );
}

export default CamWarningCard;
